import b1t1Back from './b1+t1-back';
import b1t1Front from './b1+t1-front';
import b2 from './b2';
import t2 from './t2';

export default {
  cases: [
    b2,
    b1t1Front,
    b1t1Back,
    t2,
  ],
  name: 'LR Cases',
};
